import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useBradManagementQuery } from 'api';
import { ManagementRoleMapping } from 'models/Manager';

export const useManagement = () => {
  const { id } = useParams();
  const [openEditManagement, setOpenEditManagement] = useState<boolean>(false);
  const { data: managersData = {} } = useBradManagementQuery({ id });
  const { purchaseManager, purchaseAssistantManager, postSalesManager, postSalesAssistantManager, salesManagers } =
    managersData;

  const onOpenCloseEditManagement = useCallback(() => {
    setOpenEditManagement((oState) => !oState);
  }, []);

  const managementData = useMemo(() => {
    return [
      { role: ManagementRoleMapping.purchaseManager, data: purchaseManager },
      { role: ManagementRoleMapping.purchaseManagerAssistant, data: purchaseAssistantManager },
      { role: ManagementRoleMapping.postSalesManager, data: postSalesManager },
      { role: ManagementRoleMapping.postSalesManagerAssistant, data: postSalesAssistantManager },
    ];
  }, [purchaseManager, purchaseAssistantManager, postSalesManager, postSalesAssistantManager]);

  return {
    managementData,
    onOpenCloseEditManagement,
    openEditManagement,
    salesManagers,
    managersData,
  };
};
